import { SVGProps, Ref, forwardRef } from 'react';

export const CheckDoubleOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M8.257 2.625 2.993 7.89.743 5.64 0 6.382l2.993 2.993L9 3.367z" fill="currentColor" />
            <path d="m11.257 2.625.743.742-6.008 6.008-.742-.742z" fill="currentColor" />
        </g>
    </svg>
));
CheckDoubleOutlinedSize12Glyph.displayName = 'CheckDoubleOutlinedSize12Glyph';
